import { CategoryTabContainer, TabItem } from 'components/Blog/CategoryTab';
import { useEventContext } from 'context/EventContext';
import { useRouter } from 'next/router';
import React from 'react';

type EventTypeItem = {
  label: { en: string; ko: string };
  value: 'all' | 'domestic' | 'international';
};

const tabs: EventTypeItem[] = [
  { label: { en: 'All', ko: 'All' }, value: 'all' },
  { label: { en: 'International', ko: '해외전시' }, value: 'international' },
  { label: { en: 'Domestic', ko: '국내전시' }, value: 'domestic' },
];

const EventCategoryTab = () => {
  const { locale } = useRouter();
  const {
    state: { type },
    dispatch,
  } = useEventContext(); // 전시 종류 필터
  const handleChangeEventType = (type: EventTypeItem['value']) =>
    dispatch({ type: 'change', newState: { type, currPageNum: 0 } });

  return (
    <CategoryTabContainer>
      {tabs.map(tab => (
        <TabItem key={tab.value} isSelected={tab.value === type}>
          <button onClick={() => handleChangeEventType(tab.value)}>
            {tab.label[locale]}
          </button>
        </TabItem>
      ))}
    </CategoryTabContainer>
  );
};

export default EventCategoryTab;
